module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-root"
  }, [_c('div', {
    staticClass: "top-con"
  }, [_c('el-button-group', [_c('el-autocomplete', {
    staticClass: "top-autocomplete",
    attrs: {
      "popper-class": "marker-autocomplete",
      "custom-item": "marker-autocomplete",
      "fetch-suggestions": _vm.querySearchAsync,
      "placeholder": "请输入需要查看的用户",
      "icon": "search"
    },
    on: {
      "select": _vm.handleSelect
    },
    model: {
      value: (_vm.searchVal),
      callback: function($$v) {
        _vm.searchVal = $$v
      },
      expression: "searchVal"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.openSetting
    }
  }, [_vm._v("设置")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "地图设置",
      "visible": _vm.settingVisible,
      "size": "tiny",
      "custom-class": "setting-dialog map-dialog slideInDown",
      "modal": false,
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.settingVisible = $event
      },
      "open": _vm.onOpenSetting
    }
  }, [_c('el-tabs', {
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "用户管理",
      "name": "userSetting"
    }
  }, [_c('div', {
    staticClass: "map-setting"
  }, [_c('ul', [_c('li', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('label', {
    staticStyle: {
      "width": "80px",
      "display": "inline-block"
    }
  }, [_vm._v("添加好友：")]), _vm._v(" "), _c('el-button', {
    staticClass: "add-user",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.openUserlist
    }
  }, [_vm._v("打开用户列表")])], 1), _vm._v(" "), _c('li', [_c('label', {
    staticStyle: {
      "width": "80px",
      "display": "inline-block"
    }
  }, [_vm._v("退出登录：")]), _vm._v(" "), _c('el-button', {
    staticClass: "add-user",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.logOut
    }
  }, [_vm._v("退出")])], 1)])])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "定位管理",
      "name": "mapSetting"
    }
  }, [_c('div', {
    staticClass: "map-setting"
  }, [_c('label', [_vm._v("动态查看功能：")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "on-text": "开启",
      "off-text": "关闭"
    },
    on: {
      "change": _vm.changeUpdateTrail
    },
    model: {
      value: (_vm.isUpdateTrail),
      callback: function($$v) {
        _vm.isUpdateTrail = $$v
      },
      expression: "isUpdateTrail"
    }
  })], 1)])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "用户列表",
      "visible": _vm.userListVisible,
      "size": "large",
      "custom-class": "login-dialog map-dialog slideInDown",
      "modal": true
    },
    on: {
      "update:visible": function($event) {
        _vm.userListVisible = $event
      },
      "open": _vm.onOpenSetting
    }
  }, [_c('div', {
    staticClass: "userlist",
    staticStyle: {
      "overflow": "scroll",
      "max-height": "400px"
    }
  }, [_c('ul', _vm._l((_vm.userList), function(user) {
    return _c('li', [_c('span', {
      staticClass: "user-avatar boy",
      class: {
        boy: user.sex == 1, gril: user.sex == 2
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "user-name"
    }, [_vm._v(_vm._s(user.name))]), _vm._v(" "), (user.isNotFriend) ? _c('el-button', {
      staticStyle: {
        "float": "right"
      },
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          _vm.addUser(user)
        }
      }
    }, [_vm._v("添加好友")]) : _c('el-button', {
      staticStyle: {
        "float": "right"
      },
      attrs: {
        "type": "danger"
      },
      on: {
        "click": function($event) {
          _vm.unAddUser(user)
        }
      }
    }, [_vm._v("取消好友")])], 1)
  }))])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.loginTitle,
      "visible": _vm.loginDialogVisible,
      "size": "large",
      "custom-class": "login-dialog map-dialog slideInDown",
      "modal": true,
      "show-close": false,
      "before-close": _vm.handleLoginClose
    },
    on: {
      "update:visible": function($event) {
        _vm.loginDialogVisible = $event
      },
      "open": _vm.onOpenSetting
    }
  }, [(_vm.loginComp == 'login') ? _c('login', {
    on: {
      "loginSuccess": _vm.loginSuccessCallback,
      "forgetPass": _vm.forgetPassCb,
      "registerAccount": _vm.registerAccountCb,
      "userGuide": _vm.openUserGuide
    }
  }) : (_vm.loginComp == 'register') ? _c('register', {
    on: {
      "registerSuccess": _vm.registerSuccessCallback,
      "backToLogin": _vm.backToLogin
    }
  }) : (_vm.loginComp == 'userGuide') ? _c('div', {
    staticClass: "userGuide"
  }, [_c('h3', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("欢迎您来到 基于地图的娱乐社交平台")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "first-title"
  }, [_vm._v("● 平台使用要求："), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v(" 1. 基于Android和IOS自带浏览器网络访问即可。"), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v(" 2. 请在第一次访问时提示浏览器获取您定位是点击同意确认或之后在浏览器设置中手动打开允许浏览器获取定位开关。"), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "first-title"
  }, [_vm._v("● 平台使用优势:")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v("1. 个人使用该平台可在任意出行和旅游时记录下自己的轨迹，只要坚持您将可视化地看到您的足迹已遍布大江南北大街小巷您是有多了解您的城市和国家～"), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v("2. 朋友使用该平台您们可互加好友，您们可在共同聚会出行或旅游时看到彼此共享的地图位置还可实时基于地图聊天，清清楚楚明明白白地看到和指导大家的方向和分享趣事儿～")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v("3. 第一版暂支持以上功能，将在第二和三版时支持如基于地图的动态事件新闻分享、活动分享与组织，、自定义头像和动态新消息提示、群聊和上传图片及语音等功能。")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "first-title"
  }, [_vm._v("● 平台使用方法："), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v("1、用户可通过刷新页面进入我们的应用平台，第一次登录前可通过点击使用手册查询平台介绍，第一次使用会需要点击注册账号跳转进行用户基本信息注册，请至少填写用户名、性别、密码和确认密码，然后回到登录界面进行登录。")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v("2、用户登录后可点击地图上方搜索框右边的蓝色设置按钮打开设置界面，切换到角色管理栏点击添加好友并选择想要查看位置信息和聊天的好友(第一版应用不需要验证)，之后用户便能在地图上看到对应好友的最新位置和她们聊天了。")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v("3、用户最新定位获取必须保持手机点亮和浏览器打开状态，地图将每隔20秒刷新所有用户位置及其它信息，在配置管理栏可动态开启或关闭动态查看当前用户定位功能，开启后地图更新时将始终以当前用户为中心显示，关闭后可任意查看其它地方和用户。")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v("4、点击地图上方的搜索栏可显示所有可见用户列表，点击其一可自动跳转到被选用户的地图位置查看和聊天。")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v("5、点击想要聊天的用户头像弹出聊天框可进行任意聊天(第一版暂只支持文字聊天)。")]), _vm._v(" "), _c('span', {
    staticClass: "first-title"
  }, [_vm._v(" ● 平台宗旨："), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v("始终以用户需求为平台实现目的，希望您轻松愉快地在我们平台记录您的旅行轨迹并基于地图愉快地社交，后续功能将在下一版发布，我们期待您的反馈建议并去做相应的优化和更新，谢谢使用。")])]) : _vm._e(), _vm._v(" "), (_vm.loginComp == 'userGuide') ? _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.loginComp = 'login'
      }
    }
  }, [_vm._v("返 回")])], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2549657d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/topBar.vue
// module id = 206
// module chunks = 1